import { GlideFunctionalRenderer } from "common/components/uis";
import { BaseDateTimeFieldMaterialRenderer } from "./base-date-time-field-material-renderer";

export const DateFieldMaterialRenderer: GlideFunctionalRenderer = p => {
    return <BaseDateTimeFieldMaterialRenderer {...p} variant="date" />;
};
